export const routes = {
    ASSETS: '/assets',
    DEVICE_STATE: '/device-state',
    IOT_EVENTS: '/iot-events',
    RENTAL: '/rental',
} as const;
